import React from 'react';

import SelectItem from './../selects/SelectItem';
import SelectMaterial from './../selects/SelectMaterial';
import { colorMirror } from '../../utils/colors';

export default class ModalMirror extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            diametrFlag: false,
            validFields: {
                width: false,
                height: false,
                //depth: false,
                material: false,
                color: false,
            },
            options: {
                width: [],
                height: [],
                //depth: [],
                material: [],
                color: []
            },
            currentOptions: {
                width: '',
                height: '',
                //depth: '',
                material: '',
                color: ''
            }
        }
    }

    componentDidMount() {
        this._initParameters(this.props.currentMirrorList);
        setTimeout(() => {
            if(this.state.options.height[0].value === 888) {
                this.setState({
                    diametrFlag: true
                })
            } 
        })
           
    }

    componentDidUpdate(prevProst, prevState) {
        if(JSON.stringify(prevState.currentOptions) !== JSON.stringify(this.state.currentOptions)) {
            this._validateFields();
            const filterStands = this._searchMirror();
            if(filterStands.length === 1 && this.state.currentOptions.material && this.props.currentMirrorList[0].withMaterial) {
                this.props.updatePrice(filterStands[0].material[this.state.currentOptions.material]);
            }
            if(filterStands.length === 1 && !this.props.currentMirrorList[0].withMaterial) {
                this.props.updatePrice(filterStands[0].defaultPrice);
            }
        }
    }

    _searchMirror() {
        const currentMirror = this.props.currentMirrorList.filter(mirror => {
            return mirror.width === this.state.currentOptions.width  && (this.state.diametrFlag === false && mirror.height === this.state.currentOptions.height || this.state.diametrFlag); //&& mirror.depth === this.state.currentOptions.depth;
        })
        return currentMirror;
    }

    _initMaterial(mirrors) {

        if(!mirrors[0].withMaterial) {
            return []
        }
        else {
            const materials = [];
            const mirrorItem = mirrors[0].material;
            for(let key in mirrorItem) {
                if(mirrorItem[key] !== 0 && mirrorItem[key] !== '-' && mirrorItem[key] !== '') {
                    materials.push(key)
                }
            }

            const options = [];
            materials.forEach(material => {
                for(let key in colorMirror) {
                    if(key === material) {
                        options.push({
                            value: key,
                            label: <div><span>{`${colorMirror[key][0].name}`}</span><img src={colorMirror[key][0].img}/></div>
                        })
                    }
                }
            })
            return options;
        }
    }

    _initParameters(mirrors) {
        const uniqueHeights = [];
        //const uniqueDepths = [];
        const uniqueWidths = [];
        mirrors.forEach(currentMirror => {
            const uniqueWidth = uniqueWidths.find((width) => {
                return width.value === currentMirror.width
            })

            const uniqueHeight = uniqueHeights.find((height) => {
                return height.value === currentMirror.height
            })

            // const uniqueDepth = uniqueDepths.find((depth) => {
            //     return depth.value === currentMirror.depth
            // })
            
            if(!uniqueHeight) {
                uniqueHeights.push(
                {
                    value: currentMirror.height,
                    label: `${currentMirror.height} мм`
                });
            }

            // if(!uniqueDepth) {
            //     uniqueDepths.push(
            //     {
            //         value: currentMirror.depth,
            //         label: `${currentMirror.depth} мм`
            //     });
            // }
            
            if(!uniqueWidth) {
                uniqueWidths.push(
                {
                    value: currentMirror.width,
                    label: `${currentMirror.width} мм`
                });
            }

        }); 
        const newOptions = {...this.state.options};
        newOptions.width = [...uniqueWidths];
        newOptions.height = [...uniqueHeights];
        //newOptions.depth = [...uniqueDepths];
        newOptions.material = this._initMaterial(mirrors);
        if(this.state.currentOptions.material) {
            newOptions.color = this._initColor(this.state.currentOptions.material);
        }
        
        this.setState((state) => {
            return {
                options: newOptions
            }
        })
    }

    _initColor(material) {
        let colors = [];
        let colorsOptions = []
        for(let key in colorMirror) {
            if(key === material) {
                colors = colorMirror[key][0].colors;
            }
        }
        colors.forEach(color => {
            colorsOptions.push({
                value: color.color,
                label: <div><span>{`${color.name}`}</span><img src={color.img}/></div>
            })
        })
        return colorsOptions;
    }

    _fieldsManager() {
        const filterArray = this.props.currentMirrorList.filter(mirror => {
            const checkWidth = mirror.width === this.state.currentOptions.width || this.state.currentOptions.width === '' || this.state.currentOptions.width === undefined;
            const checkHeight = mirror.height === this.state.currentOptions.height
                || this.state.currentOptions.height === ''
                || this.state.currentOptions.height === undefined
                || mirror.height === 888
            ;
            return checkWidth && checkHeight; //&& checkDepth;
        })
        this._initParameters(filterArray);
    }

    setWidth(value) {
        if(value || value === '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.width = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => {
                if(this.state.diametrFlag) {
                    this.setHeight(value)
                }
                this._fieldsManager(value)
            })
        }
        
    }

    setHeight(value) {
        if(value || value === '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.height = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    // setDepth(value) {
    //     if(value || value === '') {
    //         const options = JSON.parse(JSON.stringify(this.state.currentOptions))
    //         options.depth = value.value;
    //         this.setState(state => {
    //             return {
    //                 currentOptions: options
    //             }
    //         },
    //         () => this._fieldsManager())
    //     }
        
    // }

    setMaterial(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.material = value.value;
            options.color = '';
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    setColor(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.color = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
        
    }

    _validateFields() {
        const copyValidateObject = JSON.parse(JSON.stringify(this.state.validFields));
        const currentOptions = JSON.parse(JSON.stringify(this.state.currentOptions));
        for(let key in currentOptions) {
            if(currentOptions[key]!=='') {
                copyValidateObject[key] = true;
            }   
            else {
                if((key === 'material' || key === 'color') && this.props.currentMirrorList[0].withMaterial === false) {
                    copyValidateObject[key] = true;
                }
                else {
                    copyValidateObject[key] = false;
                }
            }

        }
        
        let checkAllValidate = true;

        for(let key in copyValidateObject) {
            if(copyValidateObject[key] === false) {
                checkAllValidate = false;
            }
        }

        if(checkAllValidate) this.props.updateValidate('mirror', true);
        else this.props.updateValidate('mirror', false);
        
        this.setState(state => {
            return {
                validFields: copyValidateObject
            }
        })
    }

    setMirror() {
        const mirror = this._searchMirror();
        const configurations = JSON.parse(JSON.stringify(this.props.srcConfig))
        configurations.mirror = {
            color: this.state.currentOptions.color,
            material: this.state.currentOptions.material,
            article: mirror[0].code,
            id: mirror[0].name.toLowerCase()
        }
        this.props.setConfiguration(configurations);
    }


    render() {
        return (
            <>
                <div className='modal-window__controls'>
                    {window.innerWidth >= 1200  ? '' : <h2 className='modal-window__controls-title'>Выберите параметры:</h2>}
                    <div className='modal-window__controls-size-group'>
                        <SelectItem handleChange = {this.setWidth.bind(this)} options = {this.state.options.width} validate={this.props.validateParts ? this.state.validFields.width : true} placeholder={this.state.diametrFlag ? "Диаметр" : 'Ширина'}/>
                        {
                            !this.state.diametrFlag ?
                            <SelectItem handleChange = {this.setHeight.bind(this)} options = {this.state.options.height} validate={this.props.validateParts ?this.state.validFields.height : true} placeholder={'Высота'}/>
                            :
                            ''
                        }
                            
                       
                        {/* <SelectItem handleChange = {this.setDepth.bind(this)} options = {this.state.options.depth} validate={this.props.validateParts ? this.state.validFields.depth : true} placeholder={'Глубина'}/> */}
                    </div>
                    {
                        this.props.currentMirrorList[0].withMaterial ?
                        <>
                            <div className='modal-window__control-view-group'>
                                <div className='modal-window__control'>
                                    <SelectMaterial handleChange = {this.setMaterial.bind(this)} validate={this.props.validateParts ? this.state.validFields.material : true} options = {this.state.options.material} placeholder={'Материал'}/>
                                </div>
                                <div className={`modal-window__control ${this.state.currentOptions.material === '' ? 'modal-window__control--disabled' : ''} `}>
                                    <SelectMaterial handleChange = {this.setColor.bind(this)} validate={this.props.validateParts ? this.state.validFields.color : true} options = {this.state.options.color} name ="color" placeholder={'Цвет'}/>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                    }
                    
                    
                    
                </div>
            </>
        )
    }
}